import React from 'react';

import { IconCheck } from '@/components/icons';
import { cn } from '@/utils/cn';

type CheckboxProps = {
  checked: boolean;
  onClick?: () => void;
  className?: string;
};

const Checkbox = ({ checked, onClick, className }: CheckboxProps) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'cursor-pointer rounded-[2px] w-6 h-6 flex items-center justify-center',
        checked ? 'bg-[#D5DC2E]' : 'border-2 border-[#DFDFDF]',
        className,
      )}
    >
      {checked && <IconCheck />}
    </button>
  );
};

export default Checkbox;
